import { useParams, useNavigate, useLocation } from "react-router-dom";
import NavHeader from "../shared/Nav-Header";
import axios from "axios";
import { useEffect, useRef, useState, useMemo } from "react";
import styles from "./profile.module.css";
import MessageBox from "../shared/MessageBox";
import Notification from '../shared/Notification';
import { useSelector, useDispatch } from 'react-redux';
import { unblockUser } from '../redux/blockSlice';
import NetworkFriends from "./NetworkFriends";
import defaultProfile1 from '../images/default-profile1.jpg';
import defaultProfile3 from '../images/default-profile3.jpg';
import { useAuth } from '../context/AuthContext';
import { 
    loadAllNetworks,
    sendFriendRequest,
    acceptFriendRequest,
    removeFriend,
    selectNetworkStatus,
    selectUserLoading,
    selectIsDataLoaded
} from '../redux/friendSlice';

const NetworkProfile = () => {

    const {networkId} = useParams();
    const [profileData, setProfileData] = useState(null);
    const [activeMessageBox, setActiveMessageBox] = useState(null);
    const [activeChat, setActiveChat] = useState(null);
    const [notification, setNotification] = useState('');
    const navigate = useNavigate();
    const location = useLocation();
    const [allMessage, setAllMessage] = useState(true);
    const [myAllMessage, setMyAllMessage] = useState(true);
    const [sendMessage, setSendMessage] = useState(false);
    // const [blockedStatus, setBlockedStatus] = useState(false);
    const blockedStatus = useSelector(state => 
        state.block.blockedUsers[networkId] || false
    );
    const dispatch = useDispatch();
    // const profilePage =''
    const [showNetworkFriendsPopup, setShowNetworkFriendsPopup] = useState(false);
    const [initialNetworks, setInitialNetworks] = useState([]);
    const { userId } = useAuth();
    const token = useMemo(() => localStorage.getItem('token'), []);
    const friendStatuses = useSelector(state => state.friend.friendStatuses);
    const status = useSelector(state => selectNetworkStatus(state, networkId));
    const isDataLoaded = useSelector(state => selectIsDataLoaded(state));
    const [discipline, setDiscipline] = useState([]);

    // useEffect(() => {
    //     if (!token) {
    //         localStorage.setItem('notification', 'You are currently Logged-out, Please login !');
    //         navigate('/login');
    //         return;
    //     }
        
    //     // Friend data load करें अगर already loaded नहीं है
    //     if (!isDataLoaded) {
    //         dispatch(loadAllNetworks());
    //     }
    // }, [token, navigate, dispatch, isDataLoaded]);
    
    useEffect(() => {

        if (!token) {
            localStorage.setItem('notification', 'You are currently Logged-out, Please login !');
            navigate('/login');
            return;
        }


        const fetchNetworkProfile = async (id) => {

            try {
                const response = await axios.get(`/api/pn/profile/${networkId}`);
                const network = response.data?.network;
                setDiscipline(response.data?.skillNames || []);

                if (network) {
                    setProfileData(network);
                    setAllMessage(network.allMessage);
                    setInitialNetworks(network.projectNetworkList?.slice(0, 10) || []);
                    setActiveChat({
                        _id: network._id,
                        name: network.name,
                        profilePicture: network.profilePicture
                    });
                    // console.log('Network profile data:', network);
                }
            } catch (error) {   
                // console.error('Error fetching network profile:', error.message);
            }
        }

        const fetchMyAllMessages = async () => {
            try {
                const response = await axios.get('/api/pn/myallmessages', {
                    headers:{
                        Authorization: `Bearer ${token}`
                    }
                });
                setMyAllMessage(response.data.myAllMessage);
                // console.log('My all messages setting:', response.data.myAllMessage);
            } catch (error) {   
                // console.error('Error fetching all messages setting:', error);
            }
        }
        fetchNetworkProfile(networkId);
        fetchMyAllMessages();
    }, [navigate]);

    useEffect(() => {
        // console.log("Checking block status for networkId:", networkId);
        const checkBlockStatus = async () => {
            try {
                // console.log("Token:", token);
                const response = await axios.get(`/api/applicant/messages/check-block-status/${networkId}`, {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                });
                // console.log('Block status response:', response.data);
                if (response.data.isBlocked) {
                    // ✅ Redux state update karo
                    dispatch({ 
                        type: 'block/setBlockStatus', 
                        payload: { userId: networkId, isBlocked: true }
                    });
                    setNotification('You blocked this user. You cannot view their profile.');
                }
            } catch (error) {
                console.error('', error);
                const errorMessage = error.response?.data?.message || 'Error checking block status:fe1';
                console.error(errorMessage);
            }
        };
        checkBlockStatus();
    }, [dispatch, networkId]);

    useEffect(() => {
        // console.log("allMessage:",allMessage);
        // console.log("myAllMessage:",myAllMessage);
        // console.log("status:",status);
        if(allMessage == true && myAllMessage == true){
            // console.log("inside 1")
            setSendMessage(true);
        }
        else if(allMessage == false && myAllMessage ==true && status == 'friends' ){
            // console.log("inside 2")
            setSendMessage(true);
        }
        else if(allMessage == true && myAllMessage == false && status == 'friends' ){
            // console.log("inside 3")
            setSendMessage(true);
        }
        else {
            // if(allMessage == false && status != 'friends' )
            // console.log("inside 4")
            setSendMessage(false);
        }
    }, [allMessage, myAllMessage]);

    // useEffect(() => {
    //     console.log("Status changed:", status);
    // }, [status]);

    // const handleAddNetwork = async () => {
    //     // console.log('Current token:', token);
    //     // console.log('Current status:', status);
    //     if (status === 'friends') {
    //         setNotification('Already Friend!');
    //         return;
    //     }
    //     else if (status === 'sent') {
    //         setNotification('Already Sent Friend Request!');
    //         return;
    //     }
    //     else if (status === 'declined-politely') {
    //         setNotification('You Can send Request acfter 21 days!');
    //         return;
    //     }
    //     else if (status === 'declined-harshly') {
    //         setNotification('Only they can send Request now!');
    //         return;
    //     }
    //     else if (status === 'received') {
    //         const handleEncourageSupport = async (networkId) => {
    //             try {
    //                 await axios.post('/api/pn/encourage-support', { networkId }, {
    //                     headers: {
    //                         Authorization: `Bearer ${token}`
    //                     }
    //                 });
    //                 setNotification('Request Accepted Successfully!');
    //                 setStatus('friends');
    //                 // setReload(true);
    //             } catch (error) {
    //                 console.error('Error supporting encouragement:', error);
    //                 setNotification('Error supporting encouragement. Please try again.');
    //             }
    //         };
    //         handleEncourageSupport(networkId);
    //     }
    //     else if (status === 'fresh') {
    //         // API
    //         const handleEncourage = async (networkId) => {
    //             try {
    //                 await axios.post('/api/pn/encouraged', { networkId }, {
    //                     headers: {
    //                         Authorization: `Bearer ${token}`
    //                     }
    //                 });
    //                 setNotification('Friend Request Sent Successfully!');
    //                 // setReload(true);
    //                 setStatus('sent');
    //             } catch (error) {
    //                 console.error('Error sending encouragement:', error);
    //                 setNotification('Error sending encouragement. Please try again.');
    //             }
    //         };
    //         handleEncourage(networkId)
    //     }
    // }

    const handleAddNetwork = async () => {
        // if (isLoadingAction) {
        //     setNotification('Please wait...');
        //     return;
        // }

        let result;
        
        switch (status) {
            case 'friends':
                setNotification('Already Friend!');
                return;
                
            case 'sent':
                setNotification('Already Sent Friend Request!');
                return;
                
            case 'declined-politely':
                setNotification('You can send request after 21 days!');
                return;
                
            case 'declined-harshly':
                setNotification('Only they can send request now!');
                return;
                
            case 'received':
                // Request accept करें
                result = await dispatch(acceptFriendRequest(networkId, profileData));
                if (result.success) {
                    setNotification('Request Accepted Successfully!');
                } else {
                    setNotification(result.error || 'Error accepting request');
                }
                break;
                
            case 'fresh':
            case 'unknown':
            default:
                // Friend request भेजें
                result = await dispatch(sendFriendRequest(networkId, profileData));
                if (result.success) {
                    setNotification('Friend Request Sent Successfully!');
                } else {
                    setNotification(result.error || 'Error sending request');
                }
                break;
        }
    };



    const handleSendMessage = async () => {
        // console.log('Send Message:', sendMessage);
        // console.log('ativeChat:', activeChat);
        // console.log("activeChat", activeChat, "status", status, "userId", userId);

        if(sendMessage){
            setActiveMessageBox(!activeMessageBox);
            return;
        }
        else{
            setNotification('You can send message only to your connections!');
        }
    };

    const onUnblockUser = async (networkId) => {
        const result = dispatch(unblockUser(networkId));
        if (result.success) {
            setNotification(result.message);
            setTimeout(() => setNotification(''), 3000);
        }
    }
    
    const showNetworkFriends = () => {
        setShowNetworkFriendsPopup(!showNetworkFriendsPopup);
        // console.log("showNetworkFriendsPopup:", showNetworkFriendsPopup);
    }
    const handleCloseNetworkFriends = () => {
        // setShowNetworkFriendsPopup(showNetworkFriendsPopup => !showNetworkFriendsPopup);
        setShowNetworkFriendsPopup(null);
        // console.log("button clicked showNetworkFriendsPopup:", showNetworkFriendsPopup);
    }

    const handleCloseChat = () => {
        setActiveMessageBox(null);
    };

    const handleCloseNotification = () => {
        setNotification('');
    };

    const handleClickOutside = (event) => {
        if (!event.target.closest(`.${styles.top}`) && !event.target.closest(`.${styles.bottom}`)) {
            setShowNetworkFriendsPopup(null);
        }
    };
    useEffect(() => {
        document.addEventListener('click', handleClickOutside);
        return () => {
            document.removeEventListener('click', handleClickOutside);
        };
    }, []);





     const handleProfileClick = (e, networkId) => {
        // e.stopPropagation();
        // e.preventDefault();
        
        navigate(`/profile/${networkId}`);
        navigate(0)
    };

    return (
        <div>
            <NavHeader />
            {notification && (
                <Notification message={notification} onClose={handleCloseNotification} />
            )}

            <div className={styles.profileContainer}>
                <div className={styles.leftSection}>
                    <img  
                        title={profileData?.name}
                        src={profileData?.profilePicture ? profileData?.profilePicture.replace('/upload/', '/upload/w_192,h_200,c_fill/') : defaultProfile1} 
                        alt="Profile" 
                        className={styles.profilePicture} 
                    />
                    <h1>Network Profile</h1>
                    {profileData && (
                        <div>
                            <h2>{profileData?.name}</h2>
                            {blockedStatus===false ? (
                                <>
                                {profileData.about ? <p>{profileData.about}</p>: <p className={styles.noAbout}>No About Info</p>}
                                <p>Education: {profileData?.education}</p>
                                    {profileData?.projectNetworkList.length>0 &&
                                        <p>Friends: </p>
                                    }
                                    {profileData?.projectNetworkList?.map((pn)=>(
                                        <span key={pn._id} className={styles.networkFriends}>
                                            <div className={styles.tooltipWrapper}>
                                                <img onClick={(e) => handleProfileClick(e, pn._id)}
                                                title={pn?.name}
                                                src={pn?.profilePicture || defaultProfile3} 
                                                // alt="Profile" 
                                                className={styles.networkFriendsPicture} 
                                                />
                                                {/* <span className={styles.tooltip}>{pn.name}</span> */}
                                            </div>
                                        </span>
                                    ))}
                                {profileData?.projectNetworkList.length>0 &&
                                <button className={`${styles.primaryAction} ${styles.top}`}
                                 onClick={() => showNetworkFriends()}>Show all</button>}
                                <div className={styles.botttom}>
                                    {showNetworkFriendsPopup && (
                                        <NetworkFriends initialNetworks={initialNetworks} networkId={networkId} handleProfileClick={(e, networkId) => handleProfileClick(e, networkId)} onClose={() => handleCloseNetworkFriends()}/>
                                    )}
                                </div>
                                </>
                            ):
                            (
                                <>
                                    <p className={styles.blockedMessageBox}>You blocked the user. </p>
                                    <button className={styles.unblockButton} onClick={() => onUnblockUser(networkId)}>Unblock User</button>
                                </>
                            )}
                        </div>
                    )}
                </div>
                <div className={styles.rightSection}>
                    {!blockedStatus &&(
                        <>
                            <h2>Social Info</h2>
                            <p>More details about the network can go here.</p>
                            <p>Education: {profileData?.education}</p>
                            <p>Skills: {Array.isArray(discipline) ? discipline.map(discipline => discipline).join(', ') : ''}</p>                        
                        </>
                    )}
                    <button className={styles.primaryAction} onClick={() => handleSendMessage()} disabled={!sendMessage} >
                        Say Hi!
                    </button>
                    <button className={styles.secondaryAction} onClick={handleAddNetwork}>
                        {status === 'friends' ? 'Connected' : status === 'received' ? '🎉 Yes! Let\'s Connect! 🎉' : status === 'sent' ? 'Sent' : status === 'declined-politely' ? 'declined-politely' : status === 'declined-harshly' ? 'declined-harshly' : 'Let\'s Connect!'}
                    </button>
                    {activeMessageBox && (
                         <MessageBox activeChat={activeChat} status={status} userId={userId} onClose={handleCloseChat} />
                    )}
                </div>
            </div>
        </div>
    );

}
export default NetworkProfile;
